import { Component } from '@angular/core';

@Component({
  selector: 'app-material-handling',
  templateUrl: './material-handling.component.html',
  styleUrls: ['./material-handling.component.scss']
})
export class MaterialHandlingComponent {
  conveyersystem:any[] = [
    {
      title: 'Flat Belt Conveyor',
      img: 'assets/images/capability/white/material_handling_1.JPG',
    },
    {
      title: 'Semi Circular Belt Conveyor',
      img: 'assets/images/capability/white/material_handling_2.JPG',
    },
    {
      title: 'Motorized Overhead Conveyor​',
      img: 'assets/images/capability/white/material_handling_3.JPG',
    },
    {
      title: 'Power & Free Conveyor',
      img: 'assets/images/capability/white/material_handling_4.JPG',
    },
    {
      title: 'Inclined Belt Conveyor',
      img: 'assets/images/capability/white/material_handling_5.JPG',
    },
    {
      title: 'Conveyor Combinations​',
      img: 'assets/images/capability/white/material_handling_6.JPG',
    },
    {
      title: 'Over Under Conveyor​',
      img: 'assets/images/capability/white/material_handling_7.JPG',
    },
    {
      title: 'Inverted Monorail',
      img: 'assets/images/capability/white/material_handling_8.JPG',
    }
  ]

  materialmove:any[] = [
    {
      title: 'Autonomous Mobile Robotics',
      img: 'assets/images/capability/white/material_handling_9.JPG',
    },
    {
      title: 'Automated Guided Vehicle',
      img: 'assets/images/capability/white/material_handling_10.JPG',
    },
    // {
    //   title: 'Honing, Super Finishing​',
    //   img: 'assets/images/capability/white/metal_to_rubber_parts.jpg',
    // },
    // {
    //   title: 'Turning​',
    //   img: 'assets/images/placeholder.jpg',
    // },
    // {
    //   title: 'Sliding Head',
    //   img: 'assets/images/placeholder.jpg',
    // },
    // {
    //   title: 'Centreless Grinding​',
    //   img: 'assets/images/placeholder.jpg',
    // }
  ]

  materialstorage:any[] = [
    {
      title: 'Milling​​​',
      img: 'assets/images/capability/white/material_handling_11.JPG',
    },
    {
      title: 'Pallet Shuttle​​',
      img: 'assets/images/capability/white/material_handling_12.JPG',
    },
    // {
    //   title: 'Honing, Super Finishing​',
    //   img: 'assets/images/capability/white/metal_to_rubber_parts.jpg',
    // },
    // {
    //   title: 'Turning​',
    //   img: 'assets/images/placeholder.jpg',
    // },
    // {
    //   title: 'Sliding Head',
    //   img: 'assets/images/placeholder.jpg',
    // },
    // {
    //   title: 'Centreless Grinding​',
    //   img: 'assets/images/placeholder.jpg',
    // }
  ]
}
